/**
 * Dong ho dem nguoc cho khoi countdown-timer.
 *
 * HAI CHE DO, co y de ca hai cung ton tai:
 *
 *   deadline — dem toi mot MOC CO THAT (vi du han dat hang de kip Giang sinh).
 *              Het gio thi khoi tu an di, khong quay vong.
 *   daily    — dem toi gio X moi ngay roi tu dat lai.
 *
 * Mac dinh la `deadline`. Ly do: moc co that vua thuc giuc vua khong mat long
 * tin, con dong ho quay vong thi khach quay lai hom sau la biet ngay minh bi
 * lua, va do la thu dat hon nhieu so voi mot don hang.
 *
 * Gio tinh theo MUI GIO CUA CUA HANG chu khong theo may khach, neu khong thi
 * mot nguoi o Sydney va mot nguoi o London se thay hai con so khac nhau cho
 * cung mot han chot.
 */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.o = this.querySelector('[data-countdown-output]');
    if (!this.o) return;
    this.tick();
    this.id_ = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.id_);
  }

  /** Moc ket thuc tiep theo, tinh bang mili giay. */
  moc() {
    if (this.dataset.mode === 'daily') {
      const gio = Number(this.dataset.resetHour || 23);
      const d = new Date();
      const h = new Date(d);
      h.setHours(gio, 0, 0, 0);
      // Qua gio hom nay roi thi nhay sang ngay mai, khong tra ve so am.
      if (h <= d) h.setDate(h.getDate() + 1);
      return h.getTime();
    }
    // Chuoi ISO kem lech mui gio cua cua hang, do Liquid dung san.
    const t = Date.parse(this.dataset.deadline || '');
    return Number.isNaN(t) ? 0 : t;
  }

  tick() {
    const con = this.moc() - Date.now();
    if (con <= 0) {
      // Het han thi AN han, dung de "00:00:00" nam do. Mot dong ho dung yen o
      // so khong la thu lam khach tin rang moi con so khac tren trang cung gia.
      clearInterval(this.id_);
      this.hidden = true;
      return;
    }
    const s = Math.floor(con / 1000);
    const ngay = Math.floor(s / 86400);
    const g = Math.floor((s % 86400) / 3600);
    const p = Math.floor((s % 3600) / 60);
    const gi = s % 60;
    const hai = (n) => String(n).padStart(2, '0');
    this.o.textContent =
      ngay > 0
        ? `${ngay}${this.dataset.dayLabel || 'd'} ${hai(g)}:${hai(p)}:${hai(gi)}`
        : `${hai(g)}:${hai(p)}:${hai(gi)}`;
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
